import { UiLoginSignupFormModel } from "../../models";

import {
    mockAdfDocument,
    mockAdfEmbeddedUiLink,
    mockAdfParagraph,
    mockAdfText,
    mockUiLinkModel,
    mockUiLinkModelContent,
    mockUiSocialLoginSignupButtonModel,
    mockUiSocialLoginSignupButtonModelContent
} from "./";

export function mockUiLoginSignupFormModel({
    id = "login-signup-form-123",
    type = "uiLoginSignupForm",
    locale = "en",
    content = mockUiLoginSignupFormModelContent()
}: Partial<UiLoginSignupFormModel> = {}): UiLoginSignupFormModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiLoginSignupFormModelContent = UiLoginSignupFormModel["content"];

export function mockUiLoginSignupFormModelContent({
    entryTitle = "Example Login Signup Form",
    formType = "signup",
    heading = "Sign up for your account",
    emailFieldLabel = "Email address",
    emailFieldPlaceholder = "Enter email",
    termsOfService = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "By signing up, you confirm that you've read and accepted our "
                    }),
                    mockAdfEmbeddedUiLink({
                        model: mockUiLinkModel({
                            content: mockUiLinkModelContent({
                                url: "#terms",
                                text: "Terms of Service"
                            })
                        })
                    }),
                    mockAdfText({
                        text: " and "
                    }),
                    mockAdfEmbeddedUiLink({
                        model: mockUiLinkModel({
                            content: mockUiLinkModelContent({
                                url: "#privacy",
                                text: "Privacy Policy"
                            })
                        })
                    }),
                    mockAdfText({
                        text: "."
                    })
                ]
            })
        ]
    }),
    continueButtonText = "Continue",
    formSeparatorText = "OR",
    socialButtons = [
        mockUiSocialLoginSignupButtonModel({
            content: mockUiSocialLoginSignupButtonModelContent({
                providerName: "google",
                buttonText: "Continue with Google"
            })
        }),
        mockUiSocialLoginSignupButtonModel({
            content: mockUiSocialLoginSignupButtonModelContent({
                providerName: "microsoft",
                buttonText: "Continue with Microsoft"
            })
        }),
        mockUiSocialLoginSignupButtonModel({
            content: mockUiSocialLoginSignupButtonModelContent({
                providerName: "apple",
                buttonText: "Continue with Apple"
            })
        }),
        mockUiSocialLoginSignupButtonModel({
            content: mockUiSocialLoginSignupButtonModelContent({
                providerName: "slack",
                buttonText: "Continue with Slack"
            })
        })
    ],
    formFooterContent = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfEmbeddedUiLink({
                        model: mockUiLinkModel({
                            content: mockUiLinkModelContent({
                                url: "#login",
                                text: "Already have an account? Log In"
                            })
                        })
                    })
                ]
            })
        ]
    }),
    browserWarningMessage = mockAdfDocument({
        content: [
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "To use Trello, please use one of our "
                    }),
                    mockAdfEmbeddedUiLink({
                        model: mockUiLinkModel({
                            content: mockUiLinkModelContent({
                                url: "#platforms",
                                text: "supported browsers"
                            })
                        })
                    }),
                    mockAdfText({
                        text: ", with JavaScript and cookies enabled."
                    })
                ]
            })
        ]
    }),
    emailButtonText = "Sign up with email",
    ...optionals
}: Partial<UiLoginSignupFormModelContent> = {}): UiLoginSignupFormModelContent {
    return {
        entryTitle,
        formType,
        heading,
        emailFieldLabel,
        emailFieldPlaceholder,
        termsOfService,
        continueButtonText,
        formSeparatorText,
        socialButtons,
        formFooterContent,
        browserWarningMessage,
        emailButtonText,
        ...optionals
    };
}
